import { render } from "./CollapsibleContainer.vue?vue&type=template&id=69b64dcf"
import script from "./CollapsibleContainer.vue?vue&type=script&lang=js"
export * from "./CollapsibleContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__